import React, { useState } from 'react';
import { Form, FormGroup, Input, Label } from 'reactstrap';
import { Btn } from '../../../AbstractElements';
import { EmailAddress, LoginWithJWT, Password, SignIn } from '../../../Constant';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import FormHeader from './FormHeader';
import FormPassword from './FormPassword';
import imgg from '../../../assets/images/logo/parikrama-logo.png';
import openEye from '../../../assets/images/logo/open-eye.png';
import closeEye from '../../../assets/images/logo/close-eye.png';
import { Jwt_token } from '../../../Config/Config';
import { ServerPath } from '../../../Constant';
import cookieUtils from '../../../utils/cookieUtils';

const LoginTab = ({ selected }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [togglePassword, setTogglePassword] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [emailFocused, setEmailFocused] = useState(false);
  const [passwordFocused, setPasswordFocused] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const loginAuth = async (e) => {
    e.preventDefault();

    // Validate form before submission for empty fields
    if (!validateForm()) {
      return; // Stop if validation fails
    }

    try {
      const response = await loginWithJwt();
      if (response.success) {
        const authi = true;
        localStorage.setItem('login', JSON.stringify(true));
        localStorage.setItem('authenticated', JSON.stringify(authi));

        // Store user data in cookies
        cookieUtils.setSecureCookie('role', response.role, { expires: 3600 });
        cookieUtils.setSecureCookie('email', response.email, { expires: 3600 });

        // Store different IDs based on role
        if (response.role === 'superadmin') {
          cookieUtils.setSecureCookie('admin_id', response.admin_id, { expires: 3600 });
        } else {
          cookieUtils.setSecureCookie('user_id', response.user_id, { expires: 3600 });
        }

        // Store additional user data
        cookieUtils.setSecureCookie('user', {
          id: response.role === 'superadmin' ? response.admin_id : response.user_id,
          email: response.email,
          role: response.role,
          name: response.name || response.admin_name
        }, { expires: 3600 });

        navigate(`${process.env.PUBLIC_URL}/dashboard`);
      } else {
        // Set generic error for any login failure
        setError('Invalid email or password');
      }
    } catch (err) {
      // Generic error for all login failures
      console.error('Login error:', err);
      setError('Invalid email or password');
    }
  };

  const loginWithJwt = async () => {
    try {
      const response = await axios.post(`${ServerPath}/admin/login`, {
        email,
        password: password.trim()
      });
      const user = response.data;
      console.log("Login Details", user)
      if (user.success) {
        console.log("in this zone");
        localStorage.setItem('Token', user.jwt_token);
        localStorage.setItem('Name', user.name);
        return user;
      } else {
        throw new Error(user.message || 'Login failed');
      }
    } catch (error) {
      console.error('Error during login:', error);
      if (error.response && error.response.data && error.response.data.message) {
        throw new Error(error.response.data.message);
      }
      throw error;
    }
  };

  const validateEmail = (email) => {
    // Email regex pattern
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailPattern.test(email);
  };

  const containsEmoji = (text) => {
    // Regex to detect emojis
    const emojiRegex = /[\u{1F000}-\u{1FFFF}|\u{2700}-\u{27BF}|\u{1F900}-\u{1F9FF}|\u{2600}-\u{26FF}|\u{2300}-\u{23FF}]/u;
    return emojiRegex.test(text);
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    if (containsEmoji(newEmail)) {
      setEmailError('Email cannot contain emojis or special characters');
      return;
    }
    setEmail(newEmail);
    if (newEmail && !validateEmail(newEmail)) {
      setEmailError('Please enter a valid email address');
    } else {
      setEmailError('');
    }
    setError(''); // Clear general error when typing
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    if (newPassword.startsWith(' ') || newPassword.endsWith(' ')) {
      setPasswordError('Password cannot start or end with spaces');
      // Option 1: Prevent spaces at beginning/end
      setPassword(newPassword.trim());
    } else {
      setPassword(newPassword);
      setPasswordError('');
    }
    setError(''); // Clear general error when typing
  };

  const validateForm = () => {
    let isValid = true;

    // Reset errors
    setEmailError('');
    setPasswordError('');
    setError('');

    // Check email
    if (!email) {
      setEmailError('Email is required');
      isValid = false;
    } else if (!validateEmail(email)) {
      setEmailError('Invalid email address');
      isValid = false;
    }

    // Check password
    if (!password) {
      setPasswordError('Password is required');
      isValid = false;
    } else if (password.trim() === '') {
      setPasswordError('Password cannot be only spaces');
      isValid = false;
    }

    return isValid;
  };

  return (
    <Form className='theme-form'>
      <center><img src={imgg} alt='' className='img-fluid' /> </center>
      <FormGroup className='mt-4'>
        <Label className='col-form-label'>{EmailAddress}</Label>
        <Input
          className={"form-control"}
          type='email'
          onChange={handleEmailChange}
          value={email}
          placeholder="Enter your email"
          onFocus={() => setEmailFocused(true)}
          onBlur={() => setEmailFocused(false)}
          style={{
            boxShadow: emailFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0.25)' : 'none',
            borderColor: emailFocused ? '#80bdff' : (emailError ? '#dc3545' : ''),
            outline: emailFocused ? 0 : ''
          }}
        />
        {emailError && <div className="invalid-feedback" style={{ display: 'block' }}>{emailError}</div>}
      </FormGroup>
      <FormGroup className='position-relative'>
        <Label className='col-form-label'>{Password}</Label>
        <div className='position-relative'>
          <Input
            className={"form-control"}
            type={togglePassword ? 'text' : 'password'}
            onChange={handlePasswordChange}
            value={password}
            placeholder="Enter your password"
            onFocus={() => setPasswordFocused(true)}
            onBlur={() => setPasswordFocused(false)}
            style={{
              boxShadow: passwordFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0.25)' : 'none',
              borderColor: passwordFocused ? '#80bdff' : (passwordError ? '#dc3545' : ''),
              outline: passwordFocused ? 0 : ''
            }}
          />
          {password.length > 0 && (
            <div className='show-hide' onClick={() => setTogglePassword(!togglePassword)} style={{ cursor: 'pointer' }}>
              <img
                src={togglePassword ? openEye : closeEye}
                alt={togglePassword ? "Hide password" : "Show password"}
                style={{ width: '20px', height: '20px', marginBottom: '5px' }}
              />
            </div>
          )}
        </div>
        {passwordError && <div className="invalid-feedback" style={{ display: 'block' }}>{passwordError}</div>}
        {/* Display the login error message below password field */}
        {error && <div className="text-danger mt-2" style={{ display: 'block' }}>{error}</div>}
      </FormGroup>
      <FormPassword />
      <div className='mt-5'>
        {selected === 'simpleLogin' ? (
          <Btn attrBtn={{ color: 'primary', className: 'd-block w-100 mt-2', onClick: (e) => loginAuth(e) }}>{SignIn}</Btn>
        ) : (
          <Btn attrBtn={{ color: 'primary', className: 'd-block w-100 mt-2', onClick: (e) => loginAuth(e) }}>{LoginWithJWT}</Btn>
        )}
      </div>
      <FormHeader selected={selected} />
    </Form>
  );
};

export default LoginTab;